import { motion } from 'framer-motion';
import React from 'react';
import styles from './ToggleButton.module.scss';

interface ToggleButtonProps {
	name?: string;
	isChecked: boolean;
	classes?: {
		toggle?: string;
		slider?: string;
		slide?: string;
	};
	disabled?: boolean;
	onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	customColors?: boolean;
}

export const ToggleButton = ({
	name,
	isChecked,
	classes,
	disabled,
	onChange,
	customColors,
}: ToggleButtonProps) => {
	const [focus, setFocus] = React.useState(false);

	return (
		<label
			htmlFor={name}
			className={`
				${styles['toggle']}
				${disabled ? styles['toggle_disabled'] : ''}
				${focus ? styles['toggle_focus'] : ''}
				${classes?.toggle ?? ''}
			`}
		>
			<input
				id={name}
				type='checkbox'
				name={name}
				checked={isChecked}
				disabled={disabled}
				onChange={onChange}
				className={styles['toggle__input']}
				onBlur={() => {
					setFocus(false);
				}}
				onFocus={() => {
					setFocus(true);
				}}
			/>
			<motion.span
				initial={false}
				animate={
					customColors ? {} : { background: isChecked ? '#40BCA3' : '#DCE2F5' }
				}
				transition={{ duration: 0.2 }}
				className={`
					${styles['toggle__slider']}
					${classes?.slider ?? ''}
				`}
			>
				<motion.span
					initial={false}
					animate={{ x: isChecked ? '100%' : 0 }}
					transition={{ duration: 0.2 }}
					className={`
						${styles['toggle__slide']}
						${classes?.slide ?? ''}
					`}
				/>
			</motion.span>
		</label>
	);
};
